import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "../fav-list-app/store";
import Favtools from "../fav-list-app/components/Favtools";

const init = () => {
  // Sorry artists, this functionality is not for you.
  if (parseInt(gage.isArtist, 10)) {
    return;
  }
  const buttons = document.querySelectorAll(".artwork-square__buttons");
  if (buttons.length) {
    buttons.forEach(button => {
      ReactDOM.render(
        <Provider store={store}>
          <Favtools
            artId={button.dataset.artworkId}
            link={button.dataset.artworkLink}
          />
        </Provider>,
        button
      );
    });
  }
};

export default init;
